import React from 'react';

import { Logo } from '../../atoms';
import { Footer } from '../../molecules';
import { ReactComponent as BackgroundShape } from '../../../assets/svg/FBQA_backgroundshape.svg';

import './default-layout.scss';

const DefaultLayout = ({ children , removePadding=false }) => {
  return (
    <>
      <div className="container">
        <div className="row">
          <BackgroundShape className="imgBackground" />
          <Logo />
          <div className="col-lg-6 col-offset-md-1 c-card">
            <div  className={`card-body ${removePadding ? "no-padding" : ""}`}>{children}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DefaultLayout;